// Public client configuration.
// These values are intentionally safe to ship in the browser bundle.
// Environment variables may override them for local/test builds.

export const PUBLIC_RUNTIME_CONFIG = {
  firebase: {
    apiKey: 'AIzaSyD4-ncBnll_CedglpSDfKVVRVH6AIK0ja0',
    authDomain: 'reelintro-cb609.firebaseapp.com',
    projectId: 'reelintro-cb609',
    storageBucket: 'reelintro-cb609.appspot.com',
    messagingSenderId: '782576471747',
    appId: '1:782576471747:web:d1a5f442164f68c24bdc76',
  },
  stripePriceIds: {
    test: {
      sixMonth: 'price_1QlfMQCWY7YPUq7bqYk9SQP7',
      lifetime: 'price_1QirApCWY7YPUq7bYE8wXyFu',
    },
    production: {
      sixMonth: 'price_1R1BKdCWY7YPUq7bqSKXpj0C',
      lifetime: 'price_1R1BKkCWY7YPUq7bKaheTCrz',
    },
  },
};
